export default __webpack_public_path__ + "static/media/redpack-logo.34a3ade8.png";